// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-2ccf-";
var _3 = "item-2KFIG";
var _4 = "delimiter-2pPP1";
var _5 = "line-cXFSn";
var _6 = "dashed-2egxp";
var _7 = "delimiterGap-3LGgf";
var _8 = "delimiterText-3t1RR";
var _9 = "content-3P-aI";
export { _1 as "__esModule", _2 as "container", _3 as "item", _4 as "delimiter", _5 as "line", _6 as "dashed", _7 as "delimiterGap", _8 as "delimiterText", _9 as "content" }
export default { "__esModule": _1, "container": _2, "item": _3, "delimiter": _4, "line": _5, "dashed": _6, "delimiterGap": _7, "delimiterText": _8, "content": _9 }
